import { normalizeNumber } from "./phoneUtils";

export const findMatchingContact = (contacts, number) => {
  return contacts.find(c =>
    normalizeNumber(String(c.defaultNumber)) === normalizeNumber(String(number))
  );
};

export const getDisplayName = (contacts, number) => {
  const matchingContact = findMatchingContact(contacts, number);
  return matchingContact
    ? `${matchingContact.first_name} ${matchingContact.last_name}`
    : number;
};
